import React from 'react'
import { Box, Typography } from '@mui/material'

export const MessageOverlay = (message: string) => (
  <Box
    position="absolute"
    bgcolor="rgba(0, 0, 0, 0.5)"
    color="#fff"
    style={{
      inset: 0,
      margin: 'auto',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1300,
      pointerEvents: 'none',
    }}
  >
    <Typography
      style={{
        pointerEvents: 'auto',
      }}
      sx={{
        whiteSpace: 'pre-line',
        textAlign: 'left',
        padding: '0 15%',
      }}
    >
      {message}
    </Typography>
  </Box>
)
